var Managers = {
    HTTP_MANAGER: "HTTP_MANAGER",
    POPUP_MANAGER: "POPUP_MANAGER",
    AD_MANAGER: "AD_MANAGER",
    AUTH_MANAGER: "AUTH_MANAGER",
    DATA_MANAGER: "DATA_MANAGER",
    STORAGE_MANAGER: "STORAGE_MANAGE",
    LANGUAGE_MANAGER: "LANGUAGE_MANAGER",
    NAVIGATION_MANAGER: "NAVIGATION_MANAGER",
    TRANSLATION_MANAGER: "TRANSLATION_MANAGER",
    MODULE_MANAGER: "MODULE_MANAGER",
    TOAST_MANAGER: "TOAST_MANAGE",
};
export default Managers;
